import { render, staticRenderFns } from "./finished.vue?vue&type=template&id=1d534847&scoped=true&"
import script from "./finished.vue?vue&type=script&lang=js&"
export * from "./finished.vue?vue&type=script&lang=js&"
import style1 from "./finished.vue?vue&type=style&index=1&id=1d534847&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d534847",
  null
  
)

export default component.exports